import { useZoomToFeatures } from '../../hooks/useZoomTo';

const ZoomTo = ({ features, zoom = 14, scale = 1 }) => {
  useZoomToFeatures(features, zoom, scale);
  return null;
};

export default ZoomTo;
